import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import Logo from 'assets/logo-dysmate.png';
import {isTablet, isIPad13, isIOS, isMacOs, getUA} from 'react-device-detect';
import Gif from 'assets/rotation-from-horizontal-to-vertical.gif';
import strings from 'utils/strings';
import {begin} from 'utils/beforeunload';
import Introduksjon from 'components/Introduksjon';
import Orddiktat from 'components/Orddiktat';
import Ordkjedetesten from 'components/Ordkjedetesten';
import Tulleordtesten from 'components/Tulleordtesten';
import Skrivehastighet from 'components/Skrivehastighet';
import Leseproven from 'components/Leseproven';
import Ordforstaelse from 'components/Ordforstaelse';
import SprakForstaelse from 'components/SprakForstaelse';
import Ferdig from 'components/Ferdig';
import getTestInfo from 'api/getTestInfo';
import getUserInfo from 'api/getUserInfo';
import getUserGrade from 'api/getUserGrade';
import upsertTestInfo from 'api/upsertTestInfo';
import {setTestCandidateGrade} from 'actions/index';

const testSteps = [
	Introduksjon,
	Orddiktat,
	Ordkjedetesten,
	Tulleordtesten,
	Skrivehastighet,
	Leseproven,
	Ordforstaelse,
	Ferdig,
];

const testStepsNorming = [
	Introduksjon,
	Orddiktat,
	SprakForstaelse,
	Ordkjedetesten,
	Tulleordtesten,
	Skrivehastighet,
	Leseproven,
	Ordforstaelse,
	Ferdig,
];

class ScreeningTest extends React.Component {
	constructor() {
		super();

		this.state = {
			isLoggedIn: false,
			isNorming: false,
			needLanguageSetting: false,
			includeAnamnese: false,
			isPortrait: true,
			isRotateDeviceFirstTimeRendered: true,
			deviceInfoSaved: false,
		};
		this.renderRemainingTests = [];
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
		this.initializeTestFlow();
	}
	componentWillUnmount() {
		window.addEventListener('resize', this.handleResize);
	}

	initializeTestFlow = async () => {
		try {
			const testInfo = await getTestInfo();
			if (!testInfo) {
				console.warn('No test info received');
				return;
			}
			const {
				exclusiveTests = {},
				isNorming = false,
				grade: rawGrade,
				anamnese,
			} = testInfo;
			console.log('rawGrade ', rawGrade);
			const grade = rawGrade !== null ? Number(rawGrade) : null;
			console.log('grade ', grade);
			if (grade !== null && !isNaN(grade)) {
				console.log('does it still shoots');
				this.props.onSetTestCandidateGrade(grade);
			}
			const includeLongIntro = anamnese === 1;
			const testToContinue = Object.values(exclusiveTests);
			if (testToContinue && testToContinue.length) {
				const continueCodes = new Set(
					testToContinue
						.map((v) => Number(v))
						.filter((n) => Number.isFinite(n))
				);

				const ordered = [];
				ordered.push({code: 1, Comp: Orddiktat});
				if (isNorming) {
					ordered.push({code: 7, Comp: SprakForstaelse});
				}
				ordered.push({code: 2, Comp: Ordkjedetesten});
				ordered.push({code: 3, Comp: Tulleordtesten});
				ordered.push({code: 4, Comp: Skrivehastighet});
				{
					ordered.push({code: 5, Comp: Leseproven});
				}
				ordered.push({code: 6, Comp: Ordforstaelse});

				this.renderRemainingTests = ordered
					.filter((step) => continueCodes.has(step.code))
					.map((step) => step.Comp);

				if (this.renderRemainingTests.length) {
					this.renderRemainingTests.push(Ferdig);
					this.setState({needLanguageSetting: true, isNorming});
				}

				this.setState({
					needLanguageSetting: true,
					includeAnamnese: includeLongIntro,
					isNorming,
				});
			}
			if (isNorming && !this.state.deviceInfoSaved) {
				try {
					var ua = '';
					if (typeof getUA === 'string' && getUA) {
						ua = getUA;
					} else if (
						typeof navigator !== 'undefined' &&
						navigator.userAgent
					) {
						ua = navigator.userAgent;
					}

					var hasNavigator = typeof navigator !== 'undefined';
					var maxTouchPoints =
						hasNavigator &&
						typeof navigator.maxTouchPoints === 'number'
							? navigator.maxTouchPoints
							: 0;

					var isLikelyIPad =
						(isMacOs && maxTouchPoints > 1) ||
						/iPad/i.test(ua) ||
						Boolean(isIPad13) ||
						(isIOS && isTablet);

					var isLikelyTablet =
						Boolean(isTablet) ||
						/iPad/i.test(ua) ||
						(isMacOs && maxTouchPoints > 1);
					await upsertTestInfo({
						testDevice: isLikelyIPad ? 'ipad' : 'non-ipad',
						isTablet: Boolean(isLikelyTablet),
					});
					this.setState({deviceInfoSaved: true});
				} catch (e) {
					console.warn('Device info upsert failed:', e);
				}
			}

			getUserInfo().then((response) => {
				if (response.ok) {
					this.setState({
						isNorming,
						isLoggedIn: true,
						includeAnamnese: includeLongIntro,
					});
					begin();
				} else {
					window.location.href = `/`;
				}
			});
		} catch (err) {
			console.error('Error initializing test flow:', err);
		}
	};

	handleResize = () => {
		if (window.innerHeight > window.innerWidth) {
			this.setState({isPortrait: true});
		} else {
			this.setState({isPortrait: false});
		}
	};
	onSelectLanguage(lang) {
		strings.setLanguage(lang);
		this.setState({
			needLanguageSetting: false,
		});
	}

	render() {
		const {
			isLoggedIn,
			isPortrait,
			isRotateDeviceFirstTimeRendered,
			includeAnamnese,
		} = this.state;

		if (!isLoggedIn) {
			return null;
		}

		const {currentStepIndex} = this.props;

		if (this.renderRemainingTests.length) {
			var CurrentStep = this.renderRemainingTests[currentStepIndex];
		} else if (this.state.isNorming) {
			var CurrentStep = testStepsNorming[currentStepIndex];
		} else {
			var CurrentStep = testSteps[currentStepIndex];
		}
		if (!isPortrait && isRotateDeviceFirstTimeRendered) {
			setTimeout(() => {
				this.setState({isRotateDeviceFirstTimeRendered: false});
			}, 3000);
		}
		return (
			<div>
				<header className="lit-header">
					<h1 className="lit-logo">
						<img
							className="lit-logo__img"
							src={Logo}
							alt="literate-logo"
						/>
					</h1>
				</header>
				{Boolean(this.renderRemainingTests.length) &&
					this.state.needLanguageSetting && (
						<div className="lit-test-intro">
							<h1>{`Velg/vel språk`}</h1>

							<button
								className="lit-test-intro-language-button"
								tabIndex="1"
								onClick={() => this.onSelectLanguage('no')}
							>
								{`Norsk Bokmål`}
							</button>
							<button
								className="lit-test-intro-language-button"
								tabIndex="2"
								onClick={() => this.onSelectLanguage('nn')}
							>
								{`Norsk Nynorsk`}
							</button>
						</div>
					)}
				{isRotateDeviceFirstTimeRendered && !isPortrait && isTablet && (
					<div className="lit-test-rotation-gif">
						<img src={Gif} alt="rotate tablet gif" />
					</div>
				)}
				{!this.state.needLanguageSetting && (
					<div className="lit-wrapper--article text-center">
						<CurrentStep
							isNorming={this.state.isNorming}
							includeLongAnamnese={includeAnamnese}
						/>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentStepIndex} = state;

	return {
		currentStepIndex,
	};
};
const mapDispatchToProps = {
	onSetTestCandidateGrade: setTestCandidateGrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningTest);
